import { render, staticRenderFns } from "./income-structure.vue?vue&type=template&id=3ba17c65&"
import script from "./income-structure.vue?vue&type=script&lang=js&"
export * from "./income-structure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports